import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventDescription = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['description'] => getEvent(eventKey)(store).description;
